import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const defaultStyles = StyleSheet.create({
    holder: {
        justifyContent: 'center',
        width: '100%',
        height: '100%'
    },
    activityIndicator: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: Theme.primaryBackgroundColor,
        opacity: 0.7
    }
});

export default defaultStyles;
